import React from "react";
import { useLocale } from "hooks";
import { useStyles } from "styling/mainStyles";
import { Lightbox } from "components/common";

const DeleteText = () => {
  const classes = useStyles();
  const { localeState } = useLocale();
  const { locale } = localeState;

  return (
    <div className={classes.infoContent}>
      <p>
        Можете да изтриете вашите данни от сървъра на приложението, следвайки
        тези прости стъпки:
      </p>

      <p>
        <b>1. Отворете главната навигация и отдете на секция 'Профил'.</b>
      </p>

      <p>
        <b>2. Натиснете бутона 'Изтриване на профил'.</b>
      </p>

      <p>
        <b>3. Потвърдете, че искате да изтриете профила си в pop-up диалога.</b>
      </p>
      <p>
        Това е! Вашият акаунт и всички данни към него ще бъдат перманентно
        изтрити.
      </p>
      <Lightbox className="lightbox-img" imgSrc={`img/nav_${locale}.jpg`} />
      <Lightbox className="lightbox-img" imgSrc={`img/account_${locale}.jpg`} />
      <Lightbox
        className="lightbox-img"
        imgSrc={`img/delete_confirmation_${locale}.jpg`}
      />
    </div>
  );
};

export default DeleteText;
